import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import 'intersection-observer';
import { formatImage } from '@ifeng-fe/public_method';
const smallLazyImg =
    'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="342" height="342"><text x="80" y="200" fill="%23dcdcdc" style="font-size: 46px;">鳳凰新聞</text></svg>';
const bigLazyImg =
    'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="360" height="200"><text x="120" y="110" fill="%23dcdcdc" style="font-size: 32px;">鳳凰新聞</text></svg>';

class Short extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        handleGalleryOpen: PropTypes.func,
    };

    ref = React.createRef();

    componentDidMount() {
        const { handleGalleryOpen } = this.props;

        const observer = new IntersectionObserver(changes => {
            changes.filter(item => item.isIntersecting > 0).forEach(change => {
                const container = change.target;

                container.src = container.getAttribute('data-lazy');
                observer.unobserve(container);
            });
        });

        Array.from(this.ref.current.querySelectorAll('[data-lazyload]')).forEach(item => {
            observer.observe(item);
        });

        Array.from(this.ref.current.querySelectorAll('img')).forEach(item => {
            item.onclick = e => {
                const url = e.currentTarget.getAttribute('data-lazyload');
                const index = this.getCurrentIndex(url);

                handleGalleryOpen(index);
            };
        });
    }

    getCurrentIndex = url => {
        const { content } = this.props;

        for (let i = 0; i < content.length; i++) {
            if (content[i].includes(url)) {
                return i;
            }
        }
    };

    lessThanThreeImg = wbImages => {
        return (
            <ul className={styles.wbImgBox}>
                <li className={styles.wbImgGroup}>
                    {wbImages.length === 1 ? (
                        <div className={styles.wbImgItem}>
                            <img
                                data-lazyload={wbImages[0].bigPicUrl}
                                className={`${styles.wbImgItemPic} ${styles.onlyWbImgItemPic}`}
                                data-lazy={wbImages[0].bigPicUrl}
                                src={bigLazyImg}
                            />
                        </div>
                    ) : (
                        wbImages.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                <div className={styles.wbImgItemBox}>
                                    <img
                                        data-lazyload={item.bigPicUrl}
                                        className={styles.wbImgItemPic}
                                        data-lazy={item.smallPicUrl}
                                        src={smallLazyImg}
                                    />
                                </div>
                            </div>
                        ))
                    )}
                </li>
            </ul>
        );
    };

    equalFourImg = wbImages => {
        const imageGroup = [];

        for (let i = 0, len = wbImages.length; i < len; i += 2) {
            imageGroup.push(wbImages.slice(i, i + 2));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                <div className={styles.wbImgItemBox}>
                                    <img
                                        data-lazyload={item.bigPicUrl}
                                        className={styles.wbImgItemPic}
                                        data-lazy={item.smallPicUrl}
                                        src={smallLazyImg}
                                    />
                                </div>
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        );
    };

    greaterThanFiveImg = wbImages => {
        const imageGroup = [];
        const fillIndex = 3 - (wbImages.length % 3);

        for (let j = 0; j < fillIndex; j++) {
            wbImages.push({});
        }
        for (let i = 0, len = wbImages.length; i < len; i += 3) {
            imageGroup.push(wbImages.slice(i, i + 3));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                {item.smallPicUrl && (
                                    <div className={styles.wbImgItemBox}>
                                        <img
                                            data-lazyload={item.bigPicUrl}
                                            className={styles.wbImgItemPic}
                                            data-lazy={item.smallPicUrl}
                                            src={smallLazyImg}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        );
    };

    render() {
        const { content } = this.props;
        const wbImages = content.map(item => ({
            smallPicUrl: item.includes('.gif') ? item : formatImage(item, 342, 342),
            bigPicUrl: item,
        }));

        return (
            content &&
            content.length > 0 && (
                <div ref={this.ref} className={styles.wbImgBorder}>
                    {content.length < 4 && this.lessThanThreeImg(wbImages)}
                    {content.length === 4 && this.equalFourImg(wbImages)}
                    {content.length > 4 && this.greaterThanFiveImg(wbImages)}
                </div>
            )
        );
    }
}

export default errorBoundary(Short);
